import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";

// Fetch a PDF from the API and save it with the server-provided filename.
export async function downloadPdf(path, params, fallbackName) {
  try {
    const res = await api.get(path, { params, responseType: "blob" });
    const name = /filename="([^"]+)"/.exec(res.headers["content-disposition"] || "")?.[1] || fallbackName;
    const a = document.createElement("a");
    a.href = URL.createObjectURL(res.data); a.download = name;
    document.body.appendChild(a); a.click(); a.remove();
    setTimeout(() => URL.revokeObjectURL(a.href), 1000);
    toast.success("PDF downloaded");
  } catch (e) {
    let detail = e.response?.data?.detail;
    if (e.response?.data instanceof Blob) {
      try { detail = JSON.parse(await e.response.data.text()).detail; } catch { /* keep generic */ }
    }
    toast.error(formatApiError(detail) || "Download failed");
  }
}
